import React, { useMemo } from "react";
import clsx from "clsx";

import { IActiveLearningIssue } from "../../../../../../state";
import TextInput from "../../../../../../atoms/ActiveLearning/TextInput";
import TextArea from "../../../../../../atoms/ActiveLearning/TextArea";
import styles from "../../../ActiveLearningIssue.module.scss";
import { ReactComponent as IconLive } from "../../../../../../assets/images/ActiveLearning/icon_live.svg";
import hintImage09 from "../../../../../../assets/images/ActiveLearning/hint/img_09.webp";

type Issue3MaterialProps = {
  issue?: IActiveLearningIssue;
};

export const Issue3Material = (props: Issue3MaterialProps) => {
  const question1 = useMemo(() => {
    return props.issue?.questions.find(q => q.order_num === 1);
  }, [props.issue?.questions]);

  const question2 = useMemo(() => {
    return props.issue?.questions.find(q => q.order_num === 2);
  }, [props.issue?.questions]);

  return (
    <div className={styles.issue}>
      <div className={styles.header}>
        <span className={styles.no}>
          WORK
          {props.issue?.no && props.issue?.no < 10
            ? `0${props.issue?.no}`
            : props.issue?.no}
        </span>
        <p className={styles.title}>{props.issue?.title}</p>
        <p className={styles.read}>
          理想状況をつくり出すために、どのような行動をすれば良いかを考え、今後取り組むべき「課題」を設定しよう。
        </p>
        <p className={styles.example}>
          例：「問い」/○○県〇〇市の若者が大学を卒業したときに地元を離れないようにするためには？→「課題」/〇〇市の子育て支援を充実させ、〇〇市の魅力が若者に伝わるようにする。
        </p>
      </div>
      {question1 && <TextInput />}
      <div className={clsx(styles.card, styles.row)}>
        <div className={styles.wrapper}>
          <div className={styles.block}>
            <p className={styles.label}>
              <IconLive />
              POINT
            </p>
            <p className={styles.title}>「課題」とは？</p>
            <p className={styles.text}>
              探究学習において、「問い」に答えを出すためにやるべきことを「課題」と呼ぶ。
              <br />
              問題や原因を整理せずに「問い」に答えを出そうとすると、不足や迷いが生まれ、答えを出すのが難しくなる。これまでに考えてきた問題/原因/理想状況を総合的に見て「課題」を設定することで、「問い」の実現性を高めることができる。
            </p>
          </div>
          <div className={styles.block}>
            <img
              className={styles.hintImage}
              src={hintImage09}
              alt="問い／問題／原因／理想状況／課題"
            />
          </div>
        </div>
      </div>
      {question2 && (
        <div className={styles.themEntry}>
          <p className={styles.title}>{question2.title}</p>
          <p className={styles.read}>
            これまでのLessonで、「問い」に答えを出すために、やるべき「課題」を設定した。
            <br />
            原因を調べたときにどんな気づきや学びがあったのか、理想状況からどのように「課題」を設定したのかを思い出して、気づいたことや考えたことを入力しよう。
          </p>
          <p className={styles.example}>
            例：問題がなぜ起きているのかを調べたときに、〇〇の問題が大きいと思っていたのに実際に大きな問題だったのは△△の問題だった。3つの理想状況を合わせたら──
          </p>
          <div className={styles.textAreaWrapper}>
            <TextArea />
          </div>
        </div>
      )}
    </div>
  );
};
export default Issue3Material;
